import { render } from "./SafetyTaskRecordCompleteList.vue?vue&type=template&id=1684219b"
import script from "./SafetyTaskRecordCompleteList.vue?vue&type=script&lang=js"
export * from "./SafetyTaskRecordCompleteList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/h5/luqiao/attendance/task/SafetyTaskRecordCompleteList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1684219b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1684219b', __exports__)) {
    api.reload('1684219b', __exports__)
  }
  
  module.hot.accept("./SafetyTaskRecordCompleteList.vue?vue&type=template&id=1684219b", () => {
    api.rerender('1684219b', render)
  })

}


export default __exports__